import {
  RESTART_PANELS_HISTORY,
  RESET_PANELS_STATE,
  SET_ACTIVE_NON_ERROR_PANEL,
  SET_ACTIVE_PANEL,
  SET_PREVIOUS_PANEL,
} from "./types";
import { panels } from "../../variables";
import { setCustomErrorMessage } from "./equeuesActions";

export const setActivePanelAction = (panelId) => ({
  type: SET_ACTIVE_PANEL,
  payload: panelId,
});

export const setActivePanel = (panelId, needToPushHistoryState = true) => (
  dispatch
) => {
  dispatch({
    type: SET_ACTIVE_PANEL,
    payload: panelId,
  });
};

export const setPreviousPanel = () => {
  return {
    type: SET_PREVIOUS_PANEL,
  };
};

export const setActiveNonErrorPanel = () => {
  return {
    type: SET_ACTIVE_NON_ERROR_PANEL,
  };
};

export const resetPanelsState = () => ({
  type: RESET_PANELS_STATE,
});

export const restartPanelsHistory = () => ({
  type: RESTART_PANELS_HISTORY,
});

export const setCustomErrorPanel = (error) => (dispatch) => {
  dispatch(setCustomErrorMessage(error));
  dispatch(setActivePanel(panels.customError));
};

export const setErrorPanel = (message, isCustom) => (dispatch) => {
  if (isCustom) {
    dispatch(setCustomErrorPanel(message));
  } else {
    dispatch(setActivePanel(panels.error));
  }
};
